import React from "react";
import { Skeleton, Stack } from "@mui/material";
import styled from "@emotion/styled";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
const CustomSkeleton = styled(Skeleton)`
  height: 2rem;
  width: 10rem;
`;

const SkeletonLayout = () => {
  return (
    <Table aria-label="simple table">
      <TableHead>
        <TableRow>
          {Array(4)
            .fill(true)
            .map((index, item) => (
              <TableCell>
                <CustomSkeleton variant="text" />
              </TableCell>
            ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {Array(5)
          .fill(true)
          .map((index, item) => (
            <TableRow>
              <TableCell>
                <Stack>
                  <Stack direction="row" gap="0.8rem">
                    <Skeleton
                      variant="text"
                      sx={{ fontSize: "2rem" }}
                      width="16.2rem"
                    />
                    <Skeleton
                      variant="text"
                      sx={{ fontSize: "2rem" }}
                      width="6.3rem"
                    />
                  </Stack>
                  <Stack>
                    <Skeleton
                      variant="text"
                      sx={{ fontSize: "2rem" }}
                      width="21.3rem"
                    />
                  </Stack>
                </Stack>
              </TableCell>
              <TableCell>
                <Skeleton variant="rounded" height="4.8rem" width="49.5rem" />
              </TableCell>
              <TableCell>
                <Skeleton
                  variant="text"
                  sx={{ fontSize: "1.6rem", width: "14.3rem" }}
                />
              </TableCell>
            </TableRow>
          ))}
      </TableBody>
    </Table>
  );
};

export const TableCampaignStageSkeleton = () => {
  return (
    <Table aria-label="simple table">
            <TableBody>
            <TableRow>
              <TableCell sx={{borderBottom: 'none' }}>
                <Skeleton variant="rounded" height="4.8rem" width="49.5rem" />
              </TableCell>
              </TableRow>
          </TableBody>     
    </Table>
  )
}

export default SkeletonLayout;
